import React from 'react';
import { Col } from 'antd';
import { I18n } from '@aws-amplify/core';

export function Content() {
	return (
		<>
			<Col span={24}>
				<span>
					<b>-1:</b> - {I18n.get('Less than 30 minutes continuously, or less than an hour per day')}
				</span>
			</Col>
			<Col span={24}>
				<span>
					<b>0:</b> - {I18n.get('Between 30 minutes to 1 hour continuously, or beteewn 1 to 4 hours a day')}
				</span>
			</Col>
			<Col span={24}>
				<span>
					<b>+1:</b> - {I18n.get('More than 1 hour continuously, or more than 4 hours per day')}
				</span>
			</Col>
		</>
	);
}
